import { baseApi } from "./api";
import {
    fgResetPassUrl,
  fgSendOtpUrl,
  fgVerifyOtpUrl,
  loginUrl,
  registerUrl,
  signUpSendOtpUrl,
  signUpVerifyOtpUrl,
} from "../constant/Api";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (post) => ({
        url: loginUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    signUpSendOtp: builder.mutation({
      query: (post) => ({
        url: signUpSendOtpUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    signUpVerifyOtp: builder.mutation({
      query: (post) => ({
        url: signUpVerifyOtpUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    registerUser: builder.mutation({
      query: (post) => ({
        url: registerUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    fgSendOtp: builder.mutation({
      query: (post) => ({
        url: fgSendOtpUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    fgVerifyOtp: builder.mutation({
      query: (post) => ({
        url: fgVerifyOtpUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
    fgResetPass: builder.mutation({
      query: (post) => ({
        url: fgResetPassUrl,
        method: "POST",
        body: post,
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response ?? response : response;
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useSignUpSendOtpMutation,
  useSignUpVerifyOtpMutation,
  useRegisterUserMutation,
  useFgSendOtpMutation,
  useFgVerifyOtpMutation,
  useFgResetPassMutation
} = authApi;
